import { OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import type { UserRecordLinkProps } from '../../../utils/linked-user-utils';
import UserRecordLinkBase from './user-record-link-base.component';

interface HfUserRecordLinkProps extends UserRecordLinkProps {
  control?: Control;
  name?: string;
}

export default function HfUserRecordLink({
  control,
  name,
  id,
  label,
  value,
  readOnly,
  required,
  recordLinkFormat,
  buttonCaption,
  showSelectButton = false,
  createExternalUsers = false,
  onChange,
  saveRecord,
}: HfUserRecordLinkProps) {
  return (
    <OdinController
      name={name as string}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <UserRecordLinkBase
          id={id}
          label={label}
          value={value}
          readOnly={readOnly}
          required={required}
          recordLinkFormat={recordLinkFormat}
          buttonCaption={buttonCaption}
          showSelectButton={showSelectButton}
          createExternalUsers={createExternalUsers}
          onChange={onChange}
          saveRecord={saveRecord}
          error={error?.message}
        />
      )}
    />
  );
}
